var _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _g3, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPackageBasic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 79,
    viewBox: "0 0 79 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -15,
    y: -15,
    width: 109,
    height: 109
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(7.5px)",
      clipPath: "url(#bgblur_0_54515_50334_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 15
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 39.5,
    r: 39,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 39.5,
    r: 39,
    stroke: "url(#paint0_radial_54515_50334)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 39.5,
    r: 39,
    stroke: "url(#paint1_radial_54515_50334)"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: -15,
    y: -15,
    width: 109,
    height: 109
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(7.5px)",
      clipPath: "url(#bgblur_1_54515_50334_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 15
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 39.5,
    r: 39,
    fill: "url(#paint2_radial_54515_50334)",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 39.5,
    r: 39,
    stroke: "url(#paint3_radial_54515_50334)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 39.5,
    r: 39,
    stroke: "url(#paint4_radial_54515_50334)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3673 35.0312V39.0475C21.7735 38.41 20.1877 37.7725 18.594 37.135C20.1877 36.4337 21.7735 35.7325 23.3673 35.0312Z",
    fill: "#FFBC1C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4219 37.1341C56.5652 37.8752 54.7005 38.6242 52.8438 39.3653V34.6797C54.7005 35.5005 56.5652 36.3133 58.4219 37.1341Z",
    fill: "#FFBC1C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8972 47.3539C51.5122 48.6852 50.0252 49.3488 48.7673 48.7508L31.9896 40.7751C30.9835 40.2968 30.4695 39.161 30.7774 38.0963L38.7878 10.3954C39.1727 9.06418 40.6598 8.4005 41.9177 8.9985L58.6954 16.9742C59.7015 17.4525 60.2155 18.5883 59.9076 19.653L51.8972 47.3539Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2334 50.8383C48.8484 52.1695 47.3614 52.8332 46.1035 52.2352L29.3257 44.2595C28.3197 43.7812 27.8057 42.6454 28.1136 41.5807L36.124 13.8798C36.5089 12.5485 37.9959 11.8849 39.2539 12.4829L56.0316 20.4586C57.0377 20.9369 57.5516 22.0727 57.2438 23.1374L49.2334 50.8383Z",
    fill: "#C5BED6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4863 54.0766C46.1014 55.4078 44.6143 56.0715 43.3564 55.4735L26.5787 47.4977C25.5726 47.0195 25.0586 45.8836 25.3665 44.8189L33.3769 17.1181C33.7619 15.7868 35.2489 15.1232 36.5068 15.7212L53.2845 23.6969C54.2906 24.1752 54.8046 25.311 54.4967 26.3757L46.4863 54.0766Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7212 57.1195C43.3362 58.4508 41.8492 59.1144 40.5913 58.5165L23.8135 50.5407C22.8075 50.0624 22.2935 48.9266 22.6014 47.8619L30.6118 20.1611C30.9967 18.8298 32.4837 18.1661 33.7417 18.7641L50.5194 26.7399C51.5255 27.2181 52.0394 28.354 51.7315 29.4187L43.7212 57.1195Z",
    fill: "#C5BED6"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_54515_50334)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.5785 34.2324C44.3226 34.6263 44.6962 35.4819 44.4791 36.2954L38.6818 58.024C38.3847 59.1374 37.1353 59.6921 36.1102 59.1655L20.5547 51.1755C19.7984 50.787 19.4152 49.9238 19.6344 49.1023L25.434 27.365C25.7288 26.2601 26.9629 25.7034 27.9863 26.2137L29.7317 27.084C30.756 27.5948 31.9911 27.0367 32.2847 25.9304L32.6992 24.3685C32.9951 23.2534 34.246 22.6974 35.272 23.2249L39.4676 25.3821C40.2217 25.7698 40.6048 26.6297 40.3887 27.4496L39.576 30.5338C39.362 31.346 39.7357 32.1985 40.4781 32.5914L43.5785 34.2324Z",
    fill: "url(#paint5_linear_54515_50334)"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5 67.4141V45.1016C40.3647 47.2292 42.2267 49.3542 44.0861 51.4766C48.8594 49.2852 53.638 47.0938 58.4219 44.9023V57.8516C51.7839 61.0391 45.1433 64.2266 38.5 67.4141Z",
    fill: "#FFBD18"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5 45.1017V67.4142C31.862 64.2267 25.2214 61.0392 18.5781 57.8517V44.8945C23.3594 47.0939 28.1406 49.288 32.9219 51.4767C34.7786 49.3491 36.638 47.2241 38.5 45.1017ZM35.3125 61.0392V57.0548C33.9817 56.5209 32.6589 55.995 31.3281 55.4611V59.4455C32.6589 59.9794 33.9817 60.5053 35.3125 61.0392Z",
    fill: "#F7CC61"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3125 57.0547V61.0391C33.9817 60.5052 32.6589 59.9792 31.3281 59.4453V55.4609C32.6589 55.9948 33.9817 56.5208 35.3125 57.0547Z",
    fill: "#636A74"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3673 39.0453C27.6147 40.7427 31.862 42.4427 36.1094 44.1453L38.5 45.1016C36.6433 47.2292 34.7839 49.3542 32.9219 51.4766C28.1406 49.2852 23.3594 47.0911 18.5781 44.8944C16.9844 44.1612 15.3906 43.4361 13.7969 42.703C15.3986 40.8462 16.9977 38.9895 18.5941 37.1328C20.1878 37.7703 21.7736 38.4078 23.3673 39.0453Z",
    fill: "#F3D894"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8906 63.4285C40.7071 63.4285 40.5293 63.3651 40.3871 63.2491C40.2449 63.1331 40.1471 62.9716 40.1102 62.7918C40.0734 62.612 40.0997 62.425 40.1847 62.2624C40.2698 62.0998 40.4084 61.9716 40.577 61.8993L46.1552 59.5087C46.3492 59.4263 46.5681 59.4242 46.7637 59.5028C46.9593 59.5815 47.1158 59.7345 47.1988 59.9283C47.2818 60.1221 47.2846 60.341 47.2065 60.5368C47.1285 60.7327 46.976 60.8897 46.7824 60.9733L41.2043 63.3639C41.1053 63.4068 40.9985 63.4288 40.8906 63.4285Z",
    fill: "#F4A811"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8906 60.241C40.7071 60.241 40.5293 60.1776 40.3871 60.0616C40.2449 59.9456 40.1471 59.7841 40.1102 59.6043C40.0734 59.4245 40.0997 59.2375 40.1847 59.0749C40.2698 58.9123 40.4084 58.7841 40.577 58.7118L46.1552 56.3212C46.3492 56.2388 46.5681 56.2367 46.7637 56.3153C46.9593 56.394 47.1158 56.547 47.1988 56.7408C47.2818 56.9346 47.2846 57.1535 47.2065 57.3493C47.1285 57.5452 46.976 57.7022 46.7824 57.7858L41.2043 60.1764C41.1053 60.2193 40.9985 60.2413 40.8906 60.241Z",
    fill: "#F4A811"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2812 43.1891L52.8438 39.3641C54.7005 38.623 56.5652 37.8739 58.4219 37.1328C60.0156 38.9895 61.6094 40.8489 63.2031 42.7109C61.6094 43.4441 60.0156 44.1745 58.4219 44.9023C53.6406 47.0938 48.862 49.2852 44.0861 51.4766C42.2214 49.3489 40.3594 47.2239 38.5 45.1016L43.2812 43.1891Z",
    fill: "#FCD572"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_54515_50334_clip_path",
    transform: "translate(15 15)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 39.5,
    r: 39
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_54515_50334_clip_path",
    transform: "translate(15 15)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 39.5,
    r: 39
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_54515_50334",
    x: 14.1519,
    y: 19.8611,
    width: 37.6165,
    height: 48.993,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.903515,
    dy: 3.1623
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.1623
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.321296 0 0 0 0 0.234017 0 0 0 0 0.504167 0 0 0 0.36 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_54515_50334"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_54515_50334",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_54515_50334",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(63.4987 57.5792 -57.5792 175.774 -10.8664 -9.76791)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6360"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_54515_50334",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-59.5847 -63.7484 63.7484 -164.939 85.5404 88.9393)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DE7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#307FE2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_54515_50334",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(79.8259 55.3113 -19.4882 114.507 3.5 32)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44218A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494363,
    stopColor: "#4176DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5AA6F3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_54515_50334",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(63.4987 57.5792 -57.5792 175.774 -10.8664 -9.76791)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6360"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_54515_50334",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-59.5847 -63.7484 63.7484 -164.939 85.5404 88.9393)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DE7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#307FE2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_54515_50334",
    x1: 43.2382,
    y1: 27.8395,
    x2: 29.283,
    y2: 67.1055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackageBasic);
export default __webpack_public_path__ + "static/media/package-basic.396d309bed523ba5530ccdf03b7406c2.svg";
export { ForwardRef as ReactComponent };